import React from 'react';
import { ArrowRight } from 'lucide-react';
import { IMAGES, MUSIC_PAGE } from '../mock';
import Reveal from './Reveal';

const Hero = () => {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="home" className="relative flex min-h-screen items-center overflow-hidden bg-ink">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={IMAGES.hero}
          alt="Kanwal Malik performing live on stage"
          className="kenburns h-full w-full object-cover object-[52%_22%]"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/60 to-ink/10" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-transparent to-ink/50" />
        <div className="absolute inset-0 bg-[#c07a2a]/10 mix-blend-overlay" />
      </div>

      {/* Content */}
      <div className="relative z-10 mx-auto w-full max-w-[1400px] px-6 pb-24 pt-32 md:px-10">
        <Reveal>
          <p className="mb-7 text-[10px] uppercase tracking-[0.5em] text-gold md:text-[11px]">
            Singer&nbsp;&nbsp;·&nbsp;&nbsp;Composer&nbsp;&nbsp;·&nbsp;&nbsp;Songwriter&nbsp;&nbsp;·&nbsp;&nbsp;Performer
          </p>
        </Reveal>

        <Reveal delay={120}>
          <h1 aria-label="K H M" className="font-serif leading-none">
            {['K', 'H', 'M'].map((letter, i) => (
              <span
                key={letter}
                aria-hidden="true"
                className="khm-letter"
                style={{ animationDelay: `${0.15 + i * 0.18}s, ${1.2 + i * 0.6}s` }}
              >
                {letter}
              </span>
            ))}
          </h1>
        </Reveal>

        <Reveal delay={240}>
          <div className="mt-9 h-px w-16 bg-gold/80" />
        </Reveal>

        <Reveal delay={330}>
          <p className="mt-8 font-serif text-xl italic tracking-wide text-neutral-300 md:text-2xl">
            MUSIC THAT MOVES.
            <br />
            A VOICE THAT CONNECTS.
          </p>
        </Reveal>

        <Reveal delay={430}>
          <div className="mt-11 flex flex-wrap items-center gap-4">
            <a
              href={MUSIC_PAGE.album.spotify}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-listen-spotify"
              className="group inline-flex items-center gap-3 bg-gold px-7 py-3.5 text-[11px] tracking-[0.25em] text-ink transition-colors duration-300 hover:bg-gold-light"
            >
              LISTEN ON SPOTIFY
              <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-1" />
            </a>
            <button
              onClick={() => go('#booking')}
              className="group inline-flex items-center gap-3 border border-white/40 px-7 py-3.5 text-[11px] tracking-[0.25em] text-white transition-colors duration-300 hover:border-gold hover:text-gold"
            >
              BOOK KHM
              <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </div>
        </Reveal>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-9 left-6 z-10 flex items-center gap-4 md:left-10">
        <span className="relative block h-11 w-px overflow-hidden bg-white/20">
          <span className="scroll-dot absolute left-0 top-0 h-4 w-px bg-gold" />
        </span>
        <span className="text-[9px] tracking-[0.45em] text-neutral-400">SCROLL</span>
      </div>
    </section>
  );
};

export default Hero;
